import React from 'react';
import { connect } from 'react-redux';
import DOMPurify from 'dompurify';
import {toggleFavorite, refreshFavorites} from '../actions/race';
import StarIcon from '../icons/star';

class Favorites extends React.Component {

  constructor(props, context) {
    super(props, context);

    this.state = {
      autoRefresh: false
    };
  }

  toggleFavorite(leader, fav) {
    this.props.toggleFavorite(leader, fav);
  }

  navigateToRunner(runner) {
    this.props.history.push(`/race/${this.props.raceDetail.race_id}/${this.props.eventId}/${runner.$KEY}`);
  }

  turnOnRefresh() {
    this.setState({autoRefresh: true});

    const _this = this;
    this.timeout = setInterval(() => {
      _this.props.refreshFavorites();
    }, 5000);
  }

  turnOffRefresh() {
    this.setState({autoRefresh: false});

    if (this.timeout) {
      this.timeout.clearInterval();
    }

  }

  render() {

    const {favorites, raceDetail} = this.props;

    // console.log(favorites);

    // if (this.props.isMobile) {
    //   return (
    //     <div>
    //       <div className="header">
    //         <h5 className="title" style={{backgroundColor: this.props.color}}>{this.props.raceDetail.name}</h5>
    //
    //         <div className="info-block clearfix">
    //           <h3>Favorites</h3>
    //
    //           <a href={`#/race/${this.props.raceDetail.race_id}`} className="btn menubutton">Menu</a>
    //         </div>
    //       </div>
    //       <div className="entries">
    //
    //         {favorites && favorites.map((runner, idx) => (
    //           <div className="entry" data-id="{{this.ENTRY_ID}}">
    //             <div className="entry-inner clearfix">
    //               <div className="entry-text">
    //                 <a href={`#/race/${this.props.raceDetail.race_id}//${runner.$KEY}`}>
    //                   <span className="favorite-icon">&nbsp;</span>
    //                   <strong>{runner.$TEAM_NAME ? runner.$TEAM_NAME : `${runner.$FIRST_NAME} ${runner.$LAST_NAME}`}</strong>
    //                   <span>Last Seen: {runner.$LAST_LOCATION} ({runner.$LAST_TIME_OF_DAY})</span>
    //                 </a>
    //               </div>
    //             </div>
    //           </div>
    //         ))}
    //
    //
    //         {(!favorites || favorites.length === 0) &&
    //         <div className="no-results">No Favorites Yet! - <a href={`#/race/${this.props.raceDetail.race_id}/results`} className='favorites-search'>Click here to find one!</a>
    //         </div>
    //         }
    //       </div>
    //     </div>
    //   );
    // }

    const gridSegmentEventKey = !this.props.eventId || this.props.eventId === '' ? 'NONE' : this.props.eventId;
    const gridSegments = raceDetail.gridSegments[gridSegmentEventKey] || [];
    return (
      <div>
        <div className="main">
          <div className="section-leaderboard">
            <div className="section-head">
              <h1 className="section-title" id="section-title">Favorites</h1>

              <div className="section-actions">
              Auto Refresh &nbsp;

              {
              this.state.autoRefresh ? (
              <span>On</span>
              ) : (
              <a href="javascript:;" className="link-on" onClick={this.turnOnRefresh.bind(this)}>On</a>
              )
              }

              |

              {
              this.state.autoRefresh ? (
              <a href="javascript:;" className="link-off" onClick={this.turnOffRefresh.bind(this)}>Off</a>
              ) : (
              <span>Off</span>
              )
              }
              </div>
            </div>
          </div>
          <div className="table">
            <table id="table-favorites" width="100%" border="0" cellSpacing="0" cellPadding="0">
              <thead>
                {!this.props.raceDetail.columns ?
                  (
                  <tr>
                    <th width="45">Fav</th>
                    <th width="36">Place</th>
                    <th>Div</th>
                    <th>Div Pl</th>
                    <th>Name</th>
                    <th>Age</th>
                    <th>City</th>
                    <th width="50">St</th>

                    {
                      gridSegments.map((segment, idx) => (
                        <th key={idx}>{segment.location}</th>
                      ))
                    }

                    <th>Time</th>

                  </tr>
                  ) : (
                   <tr>
                     <th width="45">Fav</th>
                     <th width="36">Place</th>
                     {this.props.raceDetail.columns['Div'] &&
                     <th>Div</th>
                     }

                     {this.props.raceDetail.columns['Div Pl'] &&
                     <th>Div Pl</th>
                     }

                     {this.props.raceDetail.columns['Name'] &&
                     <th>Name</th>
                     }

                     {this.props.raceDetail.columns['Age'] &&
                     <th>Age</th>
                     }

                     {this.props.raceDetail.columns['City'] &&
                     <th>City</th>
                     }

                     {this.props.raceDetail.columns['St'] &&
                     <th>St</th>
                     }

                     {this.props.raceDetail.columns['Country'] &&
                     <th>Country</th>
                     }

                     {this.props.raceDetail.columns['Gender'] &&
                     <th>Gender</th>
                     }

                     {this.props.raceDetail.columns['Club'] &&
                     <th>Club</th>
                     }

                     {this.props.raceDetail.columns['Bib #'] &&
                     <th>Bib #</th>
                     }

                     {
                       gridSegments.map((segment, idx) => (
                         <th key={idx}>{segment.location}</th>
                       ))
                     }

                     <th>Time</th>
                   </tr>

                  )
                }


              </thead>
              {!this.props.raceDetail.columns ?
                (
                  <tbody>
                    {!this.props.results || this.props.results.length === 0 &&
                      <tr><td colSpan="100">No Favorites Selected Yet</td></tr>
                    }
                  {favorites && favorites.map((runner, idx) => (
                    <tr className="highlited" key={idx} onClick={this.navigateToRunner.bind(this, runner)}>
                      <td className="aligncenter">
                        <div className="checkbox custom-checkbox">
                          <input type="checkbox" className="fav2" />

                          <label htmlFor="fav1">

                            {this.props.favorites && this.props.favorites.filter(x => x.$KEY === runner.$KEY).length > 0 ? (
                              <StarIcon checked style={{height: '22px', width: '22px'}}  onClick={this.toggleFavorite.bind(this, runner, false)} />
                            ) : (
                              <StarIcon checked={false} style={{height: '22px', width: '22px'}} onClick={this.toggleFavorite.bind(this, runner, true)} />
                            )}
                          </label>
                        </div>

                      </td>

                      <td className="aligncenter" dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(runner.$OVERALL || '')}} />

                      <td className="" dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(runner.$DIV || '')}} />
                      <td className="aligncenter" dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(runner.$DIV_PLACE || '')}} />
                      <td className="athleterow">{runner.$TEAM_NAME || `${runner.$FIRST_NAME} ${runner.$LAST_NAME}`}</td>
                      <td className="aligncenter" dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(runner.$USAT_AGE || '')}} />
                      <td className="" dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(runner.$CITY || '')}} />
                      <td className="aligncenter" dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(runner.$STATE || '')}} />

                      {
                        gridSegments.map((segment, idx) => (
                          <td key={idx} className="athleterow" dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(runner[segment.current_segment])}} />
                        ))
                      }

                      <td className="athleterow" dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(runner.$FINALTM || '')}} />


                    </tr>
                  ))}
                  </tbody>
                ) : (
                  <tbody>
                  {!this.props.results || this.props.results.length === 0 &&
                    <tr><td colSpan="100">{this.props.raceDetail.no_results_msg || 'No Results Yet'}</td></tr>
                  }
                  {favorites && favorites.map((runner, idx) => (
                    <tr className="highlited" key={idx} onClick={this.navigateToRunner.bind(this, runner)}>
                      <td className="aligncenter">
                        <div className="checkbox custom-checkbox">
                          <input type="checkbox" className="fav2" />

                          <label htmlFor="fav1">

                            {this.props.favorites && this.props.favorites.filter(x => x.$KEY === runner.$KEY).length > 0 ? (
                              <StarIcon checked style={{height: '22px', width: '22px'}}  onClick={this.toggleFavorite.bind(this, runner, false)} />
                            ) : (
                              <StarIcon checked={false} style={{height: '22px', width: '22px'}} onClick={this.toggleFavorite.bind(this, runner, true)} />
                            )}
                          </label>
                        </div>

                      </td>
                      <td className="aligncenter" dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(runner.$OVERALL || '')}} />

                      {this.props.raceDetail.columns['Div'] &&
                      <td className="" dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(runner.$DIV || '')}} />
                      }

                      {this.props.raceDetail.columns['Div Pl'] &&
                      <td className="aligncenter" dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(runner.$DIV_PLACE || '')}} />
                      }

                      {this.props.raceDetail.columns['Name'] &&
                      <td dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(runner.$TEAM_NAME || `${runner.$FIRST_NAME} ${runner.$LAST_NAME}`)}} />
                      }

                      {this.props.raceDetail.columns['Age'] &&
                      <td className="aligncenter" dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(runner.$USAT_AGE)}} />
                      }

                      {this.props.raceDetail.columns['City'] &&
                      <td className="" dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(runner.$CITY || '')}} />
                      }

                      {this.props.raceDetail.columns['St'] &&
                      <td className="aligncenter" dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(runner.$STATE || '')}} />
                      }

                      {this.props.raceDetail.columns['Country'] &&
                      <td className="" dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(runner.$COUNTRY || '')}} />
                      }

                      {this.props.raceDetail.columns['Gender'] &&
                      <td className="aligncenter" dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(runner.$SEX || '')}} />
                      }

                      {this.props.raceDetail.columns['Club'] &&
                      <td className="" dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(runner.$CLUB_NAME || '')}} />
                      }

                      {this.props.raceDetail.columns['Bib #'] &&
                      <td className="aligncenter" dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(runner.$KEY || '')}} />
                      }

                      {
                        gridSegments.map((segment, idx) => (
                          <td key={idx} className="athleterow" dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(runner[segment.current_segment])}} />
                        ))
                      }

                      <td className="athleterow" dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(runner.$FINALTM || '')}} />

                    </tr>
                  ))}

                  </tbody>
                )

              }



            </table>
          </div>
        </div>
      </div>
  );
  }
}

function mapStateToProps(state) {
  return {
    favorites: state.rr360.favorites,
    raceDetail: state.rr360.raceDetail,
    eventId: state.rr360.eventId,
    isMobile: state.rr360.isMobile,
    color: state.rr360.theme.primaryColor,
    sortBy: state.rr360.sortBy,
    sortDir: state.rr360.sortDir
  };
}

export default connect(mapStateToProps, {toggleFavorite, refreshFavorites})(Favorites);



// WEBPACK FOOTER //
// ./src/components/Favorites.js